import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import {
  DocumentSearchRequest,
  GetDocumentPageParams,
} from "apis/data-contracts";

const useDocumentsQuery = (
  options: GetDocumentPageParams & DocumentSearchRequest,
) => {
  return useSuspenseQuery({
    queryKey: ["app", "document", "search", options],
    queryFn: () =>
      api.document.getDocumentPage(
        {
          page: options.page,
          size: options.size,
          sort: options.sort,
        },
        {
          ...options,
        },
      ),
  });
};

export default useDocumentsQuery;
